<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <!-- Breadcrumbs -->
        <Breadcrumbs :items="items" />
        <v-card class="mx-auto" max-width="1000" elevation="1">
          <v-toolbar color="#343F53">
            <v-card-title
              class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
            >
              <span style="color: white">ALTERAR SENHA</span>
            </v-card-title>
          </v-toolbar>

          <v-card-text class="pa-6">
            <v-form
              @submit.prevent="alterarSenha"
              ref="form"
              v-model="formValid"
            >
              <!-- Senha Atual -->
              <v-text-field
                v-model="senhaAtual"
                :append-inner-icon="showSenhaAtual ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showSenhaAtual ? 'text' : 'password'"
                label="Senha Atual"
                placeholder="Digite sua senha atual"
                :rules="senhaAtualRules"
                @click:append-inner="showSenhaAtual = !showSenhaAtual"
                outlined
                dense
                autocomplete="current-password"
              ></v-text-field>

              <!-- Nova Senha -->
              <v-text-field
                v-model="senhaNova"
                :append-inner-icon="showSenhaNova ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showSenhaNova ? 'text' : 'password'"
                label="Nova Senha"
                placeholder="Digite sua nova senha"
                :rules="senhaNovaRules"
                @click:append-inner="showSenhaNova = !showSenhaNova"
                outlined
                dense
                autocomplete="new-password"
                class="mt-4"
              ></v-text-field>

              <!-- Confirmar Nova Senha -->
              <v-text-field
                v-model="confirmarSenhaNova"
                :append-inner-icon="
                  showConfirmarSenha ? 'mdi-eye-off' : 'mdi-eye'
                "
                :type="showConfirmarSenha ? 'text' : 'password'"
                label="Confirmar Nova Senha"
                placeholder="Confirme sua nova senha"
                :rules="confirmarSenhaRules"
                @click:append-inner="showConfirmarSenha = !showConfirmarSenha"
                outlined
                dense
                autocomplete="new-password"
                class="mt-4"
              ></v-text-field>

              <div class="d-flex justify-end mt-6">
                <v-btn
                  color="#343F53"
                  variant="outlined"
                  class="mr-4"
                  @click="limparFormulario"
                  :disabled="loading"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="#343F53"
                  type="submit"
                  :loading="loading"
                  :disabled="!formValid || loading"
                >
                  Alterar Senha
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from "./Footer.vue";
import Navbar from "@/components/restrito/Navbar.vue";
import Sidebar from "@/components/restrito/Sidebar.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import { useToast } from "vue-toastification";
import Breadcrumbs from "@/components/utils/Breadcrumbs.vue";
const toast = useToast();

export default {
  name: "AlterarSenha",
  components: { Footer, Navbar, Sidebar, Breadcrumbs },
  data() {
    return {
      items: [
        {
          title: "Início",
          disabled: false,
          href: "/admin/despedidas",
        },
        {
          title: "Alterar Senha",
          disabled: true,
        },
      ],
      formValid: false,
      loading: false,

      // Campos do formulário
      senhaAtual: "",
      senhaNova: "",
      confirmarSenhaNova: "",

      // Controle de visibilidade das senhas
      showSenhaAtual: false,
      showSenhaNova: false,
      showConfirmarSenha: false,

      // Regras de validação
      senhaAtualRules: [(v) => !!v || "A senha atual é obrigatória"],
      senhaNovaRules: [
        (v) => !!v || "A nova senha é obrigatória",
        (v) =>
          (v && v.length >= 6) || "A senha deve ter pelo menos 6 caracteres",
        (v) =>
          (v && v !== this.senhaAtual) ||
          "A nova senha deve ser diferente da senha atual",
      ],
      confirmarSenhaRules: [
        (v) => !!v || "Confirme sua nova senha",
        (v) => v === this.senhaNova || "As senhas não conferem",
      ],
    };
  },
  methods: {
    alterarSenha() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      // Preparar os parâmetros para a API
      const params = new URLSearchParams();
      params.append("senhaAntiga", this.senhaAtual);
      params.append("senhaNova", this.senhaNova);

      http
        .put("usuario/alterarsenha", params, {
          headers: authHeader(),
        })
        .then((response) => {
          toast.success("Senha alterada com sucesso!");
          this.limparFormulario();
          console.log(response);
          setTimeout(() => {
            this.$router.push("/admin/despedidas");
          }, 2000);
        })
        .catch((error) => {
          console.error("Erro ao alterar senha:", error);
          const mensagem =
            error.response?.data?.message ||
            "Erro ao alterar senha. Verifique se a senha atual está correta.";
          toast.error(mensagem);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    limparFormulario() {
      this.$refs.form.reset();
      this.senhaAtual = "";
      this.senhaNova = "";
      this.confirmarSenhaNova = "";
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}

</style>
